import {
  CreateSiteInvoiceableInput,
  UpdateSiteInvoiceableInput,
} from '@shared/services/gql.service';

import { SiteInvoiceableRowData } from '../types/site-budget-grid-row';

export const convertToCreateSiteInvoiceableInput = (
  rows: SiteInvoiceableRowData[],
  siteId: string,
  siteBudgetVersionId: string,
  patientProtocolSubTypeId: string,
  patientProtocolVersionId: string
): CreateSiteInvoiceableInput[] => {
  return rows.map((row) => ({
    amount: row.amount ?? 0,
    frequency: row.frequency,
    note: row.note || null,
    patient_protocol: {
      name: row.name,
      patient_protocol_sub_type_id: patientProtocolSubTypeId,
      patient_protocol_version_id: patientProtocolVersionId,
    },
    site_budget_version_id: siteBudgetVersionId,
    site_id: siteId,
  }));
};

export const convertToUpdateSiteInvoiceableInput = (
  rows: SiteInvoiceableRowData[],
  siteId: string,
  patientProtocolSubTypeId: string,
  patientProtocolVersionId: string
): UpdateSiteInvoiceableInput[] => {
  return rows.map((row) => {
    return {
      amount: row.amount ?? 0,
      clear_frequency: !row.frequency,
      frequency: row.frequency,
      note: row.note ?? '',
      patient_protocol: {
        id: row.id,
        name: row.name,
        patient_protocol_sub_type_id: patientProtocolSubTypeId,
        patient_protocol_version_id: patientProtocolVersionId,
      },
      site_id: siteId,
    };
  });
};
